// extracted by mini-css-extract-plugin
export default {"wrapper":"Waiting_wrapper__28Eaf","loader":"Waiting_loader__5XnC3","userName":"Waiting_userName__LMyvm"};